// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Czo8g7K8Ly26z9Aut77S {
  width: 270px;
  height: 47px;
  margin-top: 7px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  font-size: 19px;
  letter-spacing: 0.02em;
  font-weight: 600;
  color: white;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.Czo8g7K8Ly26z9Aut77S span {
  position: relative;
  z-index: 1;
}
.Czo8g7K8Ly26z9Aut77S span[data-timer="startsIn"] {
  color: #FFDF1A;
}
.Czo8g7K8Ly26z9Aut77S span[data-timer="endsIn"] {
  color: #FD5900;
}
.Czo8g7K8Ly26z9Aut77S span[data-less-than-hour="true"] {
  color: #FD5900;
}
.Czo8g7K8Ly26z9Aut77S span[data-less-than-hour="false"] {
  color: #FFDF1A;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .Czo8g7K8Ly26z9Aut77S {
    font-size: 13px;
    height: 30px;
    width: 170px;
  }
}
.xCI41nWZcR9lO5P2WjKj {
  position: absolute;
  top: 0;
  left: 5px;
  right: 5px;
  height: 100%;
  overflow: clip;
}
.dWPZNQLOMKEakqF0dVVw {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transform: translateX(0);
  transition: transform 0.5s ease;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .dWPZNQLOMKEakqF0dVVw {
    gap: 8px;
  }
}
.LpsClGv0euHYMaoigC1l .dWPZNQLOMKEakqF0dVVw {
  transform: translateX(-100%);
}
.IflS6yNDUIpjdw3K0Hba {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(100%);
  transition: transform 0.5s ease;
}
.LpsClGv0euHYMaoigC1l .IflS6yNDUIpjdw3K0Hba {
  transform: translateX(0);
}
.IflS6yNDUIpjdw3K0Hba span {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/StartsIn/StartsIn.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,YAAY;IACZ,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd","sourcesContent":[".startsIn {\n  width: 270px;\n  height: 47px;\n  margin-top: 7px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  text-align: center;\n  font-size: 19px;\n  letter-spacing: 0.02em;\n  font-weight: 600;\n  color: white;\n  background-size: 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.startsIn span {\n  position: relative;\n  z-index: 1;\n}\n.startsIn span[data-timer=\"startsIn\"] {\n  color: #FFDF1A;\n}\n.startsIn span[data-timer=\"endsIn\"] {\n  color: #FD5900;\n}\n.startsIn span[data-less-than-hour=\"true\"] {\n  color: #FD5900;\n}\n.startsIn span[data-less-than-hour=\"false\"] {\n  color: #FFDF1A;\n}\n@media (--campaign-mobile) {\n  .startsIn {\n    font-size: 13px;\n    height: 30px;\n    width: 170px;\n  }\n}\n.slideWrapper {\n  position: absolute;\n  top: 0;\n  left: 5px;\n  right: 5px;\n  height: 100%;\n  overflow: clip;\n}\n.primaryContent {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  transform: translateX(0);\n  transition: transform 0.5s ease;\n}\n@media (--campaign-mobile) {\n  .primaryContent {\n    gap: 8px;\n  }\n}\n.showMoreInfo .primaryContent {\n  transform: translateX(-100%);\n}\n.moreInfo {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateX(100%);\n  transition: transform 0.5s ease;\n}\n.showMoreInfo .moreInfo {\n  transform: translateX(0);\n}\n.moreInfo span {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"startsIn": `Czo8g7K8Ly26z9Aut77S`,
	"slideWrapper": `xCI41nWZcR9lO5P2WjKj`,
	"primaryContent": `dWPZNQLOMKEakqF0dVVw`,
	"showMoreInfo": `LpsClGv0euHYMaoigC1l`,
	"moreInfo": `IflS6yNDUIpjdw3K0Hba`
};
export default ___CSS_LOADER_EXPORT___;
